function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getPath = function getPath(key, obj) {
  // eslint-disable-line @typescript-eslint/no-explicit-any
  var path = key.split('.');
  var aux = obj;
  path.forEach(function (piece) {
    if (!aux) return;
    if (!piece || piece.length === 0) {
      aux = undefined;
      return;
    }
    if (_typeof(aux) !== 'object') {
      aux = undefined;
      return;
    }
    if (Array.isArray(aux)) {
      var idx = piece.match(/\[([0-9]*)\]/);
      var id = piece.match(/{([0-9]*)}/);
      if (idx != null) {
        var arrayIdx = Number(idx[1]);
        aux = aux[arrayIdx];
      } else if (id != null) {
        var numId = Number(id[1]);
        aux = aux.find(function (item) {
          return item.id === numId;
        });
      } else {
        aux = undefined;
      }
      return;
    }
    aux = aux[piece];
  });
  return aux;
};
export default getPath;